import type { WorkflowDefinition } from './types'

/** Canonical MIM compliance journey — seeded in DB and used as frontend fallback. */
export const DEFAULT_WORKFLOW_CODE = 'mim-compliance-default'

export const defaultWorkflow: WorkflowDefinition = {
  code: DEFAULT_WORKFLOW_CODE,
  name: 'MIM compliance (default)',
  version: 1,
  steps: [
    {
      key: 'master-terms',
      sortOrder: 1,
      title: 'Set up master terms',
      shortLabel: 'Master terms',
      description:
        'Approve keywords and synonyms in Master terms before importing them into family term-reference rows.',
      primaryRoute: '/master-terms',
      routePatterns: ['/master-terms', '/term-watches'],
    },
    {
      key: 'compliance-setup',
      sortOrder: 2,
      title: 'Set up product families',
      shortLabel: 'Compliance setup',
      description:
        'In Compliance setup: use the Family and Compared attributes tabs — families, data groups, master term imports, and compared attribute rows.',
      primaryRoute: '/pim',
      routePatterns: ['/pim'],
    },
    {
      key: 'products',
      sortOrder: 3,
      title: 'Set up products',
      shortLabel: 'Products',
      description:
        'Maintain the Kingspan catalogue in products (codes, approvals, comparison scope).',
      primaryRoute: '/products',
      routePatterns: [
        '/products',
        '/products/orphaned',
        '/products/:productId',
        '/products/:productId/details',
        '/products/:productId/pim-manual',
        '/products/:productId/compliance-scope',
        '/products/:productId/compare',
      ],
    },
    {
      key: 'rule-packs',
      sortOrder: 4,
      title: 'Set up rule packs',
      shortLabel: 'Rule packs',
      description:
        'Maintain approved rule packs — they drive terminology and structured checks downstream.',
      primaryRoute: '/rules',
      routePatterns: ['/rules', '/rules/:rulePackId', '/extraction-profiles/:profileId'],
    },
    {
      key: 'distributors-targets',
      sortOrder: 5,
      title: 'Add distributors & targets',
      shortLabel: 'Distributors',
      description:
        'Record distributor sites under distributors, then line up product URLs via targets.',
      primaryRoute: '/distributors',
      routePatterns: ['/distributors', '/distributors/:distributorId/search', '/targets'],
    },
    {
      key: 'run-checks',
      sortOrder: 6,
      title: 'Run compliance checks',
      shortLabel: 'Run checks',
      description: 'Trigger runs from run checks and track progress under jobs.',
      primaryRoute: '/run-checks',
      routePatterns: ['/run-checks', '/check-runs'],
    },
    {
      key: 'findings-reports',
      sortOrder: 7,
      title: 'Review findings & distributor reports',
      shortLabel: 'Findings',
      description:
        'Inspect findings for value vs terminology gaps; share distributor action reports where required.',
      primaryRoute: '/findings',
      routePatterns: ['/findings', '/distributor-action-reports', '/actions', '/compliance-audit'],
    },
  ],
}
